import React, { createContext, useState } from "react";
import App from "../App";

export const appContext = createContext<any>({});

export const AppContext = () => {
  const departmentData = localStorage.getItem("corporate-department") || "";
  const locationData = localStorage.getItem("corporate-location") || "";
  const [department, setDepartment] = useState<string>(departmentData);
  const [location, setLocation] = useState<string>(locationData);
  const [fromDate, setFromDate] = useState<string>("");
  const [toDate, setToDate] = useState<string>("");
  const [monthValue, setMonthValue] = useState<string>("");
  return (
    <appContext.Provider
      value={{
        location,
        department,
        fromDate,
        toDate,
        monthValue,
        setLocation,
        setFromDate,
        setToDate,
        setDepartment,
        setMonthValue
      }}
    >
      <App />
    </appContext.Provider>
  );
};
